module.exports = __webpack_public_path__ + "img/1.b5262b15.jpg";